<template>
  <div class="footer-basic">
    <footer>
        <ul class="list-inline">
            <li class="list-inline-item"><router-link to="/">Home</router-link></li>
            <!-- <li class="list-inline-item"><router-link to="/about">About</router-link></li> -->
            <li class="list-inline-item"><router-link to="/terms">Terms</router-link></li>
            <li class="list-inline-item"><router-link to="/privacypolicy">Privacy Policy</router-link></li>
        </ul>
        <p class="copyright">Gokaku Essay Library 2019</p>
      </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-basic {
  padding:15px 0;
  background-color:#eee;
  color:#4b4c4d;
  bottom: 0;
  position: absolute;
  width: 100%;
}

.footer-basic ul {
  padding:0;
  list-style:none;
  text-align:center;
  font-size:18px;
  line-height:1.6;
  margin-bottom:0;
}

.footer-basic li {
  padding:0 10px;
}

.footer-basic ul a {
  color:inherit;
  text-decoration:none;
  opacity:0.8;
}

.footer-basic ul a:hover {
  opacity:1;
}

.footer-basic .social {
  text-align:center;
  padding-bottom:25px;
}

.footer-basic .social > a {
  font-size:24px;
  width:40px;
  height:40px;
  line-height:40px;
  display:inline-block;
  text-align:center;
  border-radius:50%;
  border:1px solid #ccc;
  margin:0 8px;
  color:inherit;
  opacity:0.75;
}

.footer-basic .social > a:hover {
  opacity:0.9;
}

.footer-basic .copyright {
  margin-top:15px;
  text-align:center;
  font-size:13px;
  color:#aaa;
  margin-bottom:0;
}
</style>
